// extracted by mini-css-extract-plugin
export default {"block":"connection-lost_block__QCoOT","title":"connection-lost_title__MgSiV","description":"connection-lost_description__QPihv"};